var exports = {
  "k": "xdde3148b--9bb842--container",
  "w": "xdde3148b--9bb842--header",
};

module.exports = exports;
